import React, { ReactNode } from 'react';
import { Tooltip } from '~/ui/components';

import { Info, InfoTitle, InfoValue } from './EnrollmentItem.styled';

type TicketInfoItemProps = {
  title: ReactNode;
  value?: ReactNode;
  fullWidth?: boolean;
  hideValue?: boolean;
};

export function EnrollmentItem({ title, value, fullWidth, hideValue }: TicketInfoItemProps) {
  const shouldShowTooltip = typeof value === 'string' && value?.length > 21 && !fullWidth;

  const renderValue = () => {
    const isStringValue = typeof value === 'string';

    if (value === undefined || value === null || value === false || (isStringValue && value.trim() === '')) {
      return '-';
    }

    if (isStringValue && shouldShowTooltip) {
      return (
        <Tooltip content={value} placement="bottomLeft">
          {value}
        </Tooltip>
      );
    }

    return value;
  };

  return (
    <Info fullWidth={fullWidth}>
      <InfoTitle>{title}</InfoTitle>
      {!hideValue && <InfoValue fullWidth={fullWidth}>{renderValue()}</InfoValue>}
    </Info>
  );
}
